import { motion } from "framer-motion";
import React, { FC } from "react";
import Heading from "components/Heading/Heading";
import { fadeInUp, scaleIn, staggerContainer } from "utils/motionPresets";

export interface Statistic {
  id: string;
  heading: string;
  subHeading: string;
}

const FOUNDER_DEMO: Statistic[] = [
  {
    id: "1",
    heading: "2000+",
    subHeading: "Product Range",
  },
  {
    id: "2",
    heading: "1000+",
    subHeading: "Project references",
  },
  {
    id: "3",
    heading: "10",
    subHeading: "Countries have our presence",
  },
];

export interface SectionStatisticProps {
  className?: string;
}

const SectionStatistic: FC<SectionStatisticProps> = ({ className = "" }) => {
  return (
    <div className={`nc-SectionStatistic relative ${className}`}>
      <Heading
        desc="We're impartial and independent, and every day we create distinctive, world-class engineering products"
      >
        Fast Facts
      </Heading>
      <motion.div
        className="grid md:grid-cols-2 gap-6 lg:grid-cols-3 xl:gap-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        variants={staggerContainer}
      >
        {FOUNDER_DEMO.map((item) => (
          <motion.div
            key={item.id}
            variants={scaleIn}
            className="p-8 bcr-card-modern text-center hover:shadow-bcr-card-hover group"
          >
            <h3 className="text-3xl font-bold leading-none text-primary-600 dark:text-primary-400 md:text-4xl group-hover:scale-105 transition-transform duration-300">
              {item.heading}
            </h3>
            <span className="block text-sm text-neutral-500 mt-4 sm:text-base dark:text-neutral-400 font-medium">
              {item.subHeading}
            </span>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default SectionStatistic;
